import res from './res'

res.add('en', {
    datePeriod: 'Payments for',
    code: 'status'
})
